import isNumber from 'lodash/isNumber'
import { localeString } from '@/config/helpers.js'

export default (value, digits = 0) => {
  if (value === '-') return value
  if (value || value === 0) {
    if (isNumber(value)) return localeString(value, digits)
    return localeString(value)
  } else return '-'
}
